import React from 'react';
import PropTypes from 'prop-types';

class AddressCol extends React.PureComponent {

    render() {
        const {name, address1, address2, city, state, postalCode, country, productStatus, ghtkAddress, shipmentInfo} = this.props

        if (shipmentInfo !== undefined && shipmentInfo !== null && Object.keys(shipmentInfo).length > 0) {
            return (
                <div className={productStatus === 'cancelled' ? 'notDisableCancel Address' : 'Address'}>
                    <span className='d-block'>{name || ''}</span>
                    <span className='d-block'>{ghtkAddress !== undefined ? ghtkAddress : address1 || ''}</span>
                    <span className='d-block'>{shipmentInfo.province || ''}</span>
                    <span className='d-block'>{country || ''}</span>
                </div>
            )
        }

        return (
            <div className={productStatus === 'cancelled' ? 'notDisableCancel Address' : 'Address'}>
                <span className='d-block'>{name || ''}</span>
                <span className='d-block'>{ghtkAddress !== undefined ? ghtkAddress : address1 || ''}</span>
                <span className='d-block'>{address2 || ''}</span>
                <span className='d-block'>{(city || '') + ' ' + (state || '') + ' ' + (postalCode || '')}</span>
                <span className='d-block'>{country}</span>
            </div>
        );
    }
}

AddressCol.propTypes = {
    productStatus: PropTypes.string.isRequired,
    name: PropTypes.string,
    address1: PropTypes.string,
    address2: PropTypes.string,
    city: PropTypes.string,
    state: PropTypes.string,
    postalCode: PropTypes.string,
    country: PropTypes.string,
    ghtkAddress: PropTypes.string
};

export default AddressCol;
